import {
  VAULT_CARD_REQUESTED,
  VAULT_CARD_FAILED,
  VAULT_CARD_SUCCESS,
} from '../actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const vaultCardReducer = (state = initialState, action) => {
  switch (action.type) {
    case VAULT_CARD_REQUESTED:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case VAULT_CARD_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case VAULT_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    default:
      return state;
  }
};

export default vaultCardReducer;
